/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetBasicFaresField,
  BookWidgetBestFareOptionsField,
  BookWidgetDateField,
  BookWidgetEdocsLink,
  BookWidgetFields,
  BookWidgetFlexAirportsField,
  BookWidgetFlexDatesField,
  BookWidgetMeetingEventCodeField,
  BookWidgetPassengerField,
  BookWidgetRefundableFareField,
  BookWidgetShopMilesField
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { DefaultLookupFieldsValue } from '../../models/core-apis/default-lookup.interfaces';
import { GeoLocationResponse } from '../../models/core-apis/geo-location.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { LoginDashboardFieldsConfig } from '../../models/login-dashboard.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';
import { bookWidgetFieldsRulesOnInitEval } from '../book-widget-fields-rules/on-init/book-widget-fields-rules-on-init.adapter';
import { prepareAirportsField } from './airports-field.adapter';
import { prepareBasicFaresField } from './basic-fares-field.adapter';
import { prepareBestFareOptionsField } from './best-fare-options-field.adapter';
import { prepareDatesField } from './dates-field.adapter';
import { prepareFlexAirportsField } from './flex-airports-field.adapter';
import { prepareFlexDatesField } from './flex-dates-field.adapter';
import { prepareMeetingEventCodeField } from './meeting-event-code-field.adapter';
import { preparePassengerField } from './passenger-field.adapter';
import { prepareRefundableFareField } from './refundable-fare-field.adapter';
import { prepareShopMilesField } from './shop-miles-field.adapter';
import { prepareTripTypesField } from './trip-types-field.adapter';

export const prepareBookWidgetFields = (
  bookWidgetAem: BookWidgetAem | null,
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  defaultLookupFieldsValue: DefaultLookupFieldsValue | null,
  geoLocationData: GeoLocationResponse | null,
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  queryParams: QueryParams | null,
  loginDashboardFieldsConfig: LoginDashboardFieldsConfig | null,
  edocsUrl: string,
  hasDeepLinkingParams: boolean
): BookWidgetFields => {
  const airportsField = prepareAirportsField(
    geoLocationData,
    queryParams,
    retrieveSearchData,
    hasDeepLinkingParams
  );

  const tripTypesField = prepareTripTypesField(
    bookWidgetAem,
    catalogApiFieldsValue,
    defaultLookupFieldsValue,
    queryParams,
    retrieveSearchData,
    bookWidgetFieldsMasterConfig,
    hasDeepLinkingParams
  );

  const datesField: BookWidgetDateField = prepareDatesField(
    queryParams,
    retrieveSearchData,
    hasDeepLinkingParams
  );

  const passengerField: BookWidgetPassengerField = preparePassengerField(
    bookWidgetAem,
    queryParams,
    defaultLookupFieldsValue,
    retrieveSearchData,
    catalogApiFieldsValue,
    bookWidgetFieldsMasterConfig,
    loginDashboardFieldsConfig,
    hasDeepLinkingParams
  );

  const shopMilesField: BookWidgetShopMilesField = prepareShopMilesField(
    queryParams,
    retrieveSearchData,
    bookWidgetFieldsMasterConfig,
    loginDashboardFieldsConfig,
    hasDeepLinkingParams
  );

  const refundableFareField: BookWidgetRefundableFareField =
    prepareRefundableFareField(
      retrieveSearchData,
      bookWidgetFieldsMasterConfig,
      loginDashboardFieldsConfig,
      hasDeepLinkingParams
    );

  const flexDatesField: BookWidgetFlexDatesField = prepareFlexDatesField(
    retrieveSearchData,
    bookWidgetFieldsMasterConfig,
    hasDeepLinkingParams
  );

  const basicFaresField: BookWidgetBasicFaresField = prepareBasicFaresField(
    bookWidgetFieldsMasterConfig,
    catalogApiFieldsValue,
    retrieveSearchData,
    bookWidgetAem
  );

  const flexAirportsField: BookWidgetFlexAirportsField =
    prepareFlexAirportsField(
      queryParams,
      retrieveSearchData,
      bookWidgetFieldsMasterConfig,
      hasDeepLinkingParams
    );

  const bestFareOptionsField: BookWidgetBestFareOptionsField =
    prepareBestFareOptionsField(
      bookWidgetAem,
      queryParams,
      catalogApiFieldsValue,
      defaultLookupFieldsValue,
      retrieveSearchData,
      bookWidgetFieldsMasterConfig,
      hasDeepLinkingParams
    );

  const meetingEventCodeField: BookWidgetMeetingEventCodeField =
    prepareMeetingEventCodeField(
      queryParams,
      retrieveSearchData,
      bookWidgetFieldsMasterConfig,
      hasDeepLinkingParams,
      loginDashboardFieldsConfig,
      bookWidgetAem
    );

  const edocsLink: BookWidgetEdocsLink = {
    disable: bookWidgetFieldsMasterConfig.edocsLink?.disable || false,
    hide: bookWidgetFieldsMasterConfig.edocsLink?.hide || false,
    src: edocsUrl
  };

  let bookWidgetFields: BookWidgetFields = {
    airportsField,
    tripTypesField,
    datesField,
    passengerField,
    shopMilesField,
    refundableFareField,
    flexDatesField,
    basicFaresField,
    flexAirportsField,
    bestFareOptionsField,
    meetingEventCodeField,
    edocsLink
  };

  bookWidgetFields = bookWidgetFieldsRulesOnInitEval(
    bookWidgetFields,
    bookWidgetFieldsMasterConfig
  );

  return bookWidgetFields;
};
